<template>
    <div>
        <v-autocomplete
                hide-details
                v-model="pickedIds"
                :items="items"
                item-value="id"
                item-text="name"
                @change="onChange"
                multiple
                outlined
                :loading="loading"
                v-bind="$attrs"
        >
            <template v-slot:selection="{ item, index }">
                <span
                        v-if="index === 0"
                        class="grey--text caption"
                >
                    <template v-if="pickedIds.length === 1">{{ pickedIds.length }} item</template>
                    <template v-else>{{ pickedIds.length }} items</template>
                </span>
            </template>

            <template v-slot:prepend-item v-if="!disabledCheckAll">
                <v-list-item
                        ripple
                        @click="toggle"
                >
                    <v-list-item-action>
                        <v-icon>{{ icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{$t('All')}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
            </template>
        </v-autocomplete>
        <v-flex xs12 sm12 md12 v-if="pickedItems.length > 0">
            <v-flex xs12>
                <v-card class="filter-selected my-0" color="#F8F8F8" outlined tile elevation="0">
                    <template v-for="(item, index) in pickedItems">
                        <v-chip
                                close-icon="$close"
                                close
                                outlined
                                label
                                color="#202020"
                                :key="index"
                                v-if="item"
                                class="mr-2 my-1"
                                @click:close="unpick(index)"
                        >
                            <span class="body-2">{{ item.name }}</span>
                        </v-chip>
                    </template>
                </v-card>
            </v-flex>
        </v-flex>
    </div>
</template>

<script>
  export default {
    name: "MultiplePickerInput",
    props: {
      value: { },
      items: { type: Array, default: [] },
      disabledCheckAll: { type: Boolean, default: false },
      loading: { type: Boolean, default: false }
    },
    data() {
      return {
        pickedIds: []
      }
    },
    computed: {
      isPickedAll() {
        return this.pickedIds.length === this.items.length;
      },
      isPickedSome() {
        return this.pickedIds.length > 0 && !this.isPickedAll;
      },
      pickedItems() {
        const _this = this;

        return _this.pickedIds.map((id) => {
          return _this.items.find((item) => {
            return item && item.id === id;
          })
        });
      },
      icon() {
        if (this.isPickedAll) {
          return 'fas fa-check-square';
        } else if (this.isPickedSome) {
          return 'fas fa-minus-square';
        } else {
          return 'far fa-square';
        }
      }
    },
    methods: {
      toggle () {
        const _this = this;

        this.$nextTick(() => {
          if (this.isPickedAll) {
            _this.pickedIds = []
          } else {
            _this.pickedIds = _this.items.map((item) => item && item.id);
          }

          _this.$emit('input', _this.pickedIds);
        })
      },
      unpick(index) {
        this.pickedIds.splice(index, 1);

        this.$emit('input', this.pickedIds);
      },
      onChange(value) {
        this.$emit('input', value);
      },
    },
    watch: {
      value: {
        immediate: true,
        handler(value) {
          if (!Array.isArray(value)) {
            return;
          }

          this.pickedIds = value;
        }
      },
    }
  }
</script>

<style scoped>

</style>
